import { Set } from '@blade/std-lib'

import { atomWithPrev } from './atom-with-prev'

import type { CtxSpy } from '@reatom/framework'

export const reatomSetComputed = <K>(
  computed: (ctx: CtxSpy) => Set<K>,
  args?: {
    name?: string
  },
) => {
  const name = args?.name ?? 'set-computed'
  const theAtom = atomWithPrev<Set<K>>((ctx, prev) => {
    const nextSet = computed(ctx)
    if (prev && Set.equals(prev, nextSet)) {
      return prev
    }
    return nextSet
  }, name)

  return theAtom
}
